"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BackendManager = void 0;
const lodash_1 = require("lodash");
const elements_core_rest_transport_1 = require("@hydrogen/elements.core.rest.transport");
const resource_adapt_1 = require("../adaptors/resource-adapt");
class BackendManager {
    constructor() {
        this.type = 'backend';
        this.resourceName = null;
        this.lang = {};
        this.saveManager = {
            save: () => {
            },
            load: () => ({ en: { key: '' } }),
        };
        this.ResourceAdaptor = resource_adapt_1.ResourceAdaptor;
    }
    init(services, backendOptions) {
        var _a, _b, _c, _d;
        this.resourceName = backendOptions.resourceName;
        if (!this.resourceName)
            return;
        if (typeof backendOptions.SaveManager === 'function') {
            const nameSpace = ((_d = (_c = (_b = (_a = services.resourceStore) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.ns) === null || _c === void 0 ? void 0 : _c[0]) !== null && _d !== void 0 ? _d : 'translation');
            this.saveManager = backendOptions.SaveManager(nameSpace);
        }
    }
    read(language, namespace, callback) {
        var _a, _b;
        this.lang[language] = {};
        const localResource = (_b = (_a = this.resourcesFromSessionStorage) === null || _a === void 0 ? void 0 : _a[language]) !== null && _b !== void 0 ? _b : {};
        if (Object.keys(localResource).length !== 0) {
            callback(null, this.resourcesFromSessionStorage[language]);
        }
        else {
            this.loadResource(language, namespace, callback);
        }
    }
    saveToSessionStorage(resources) {
        var _a;
        if ((_a = this.saveManager) === null || _a === void 0 ? void 0 : _a.save) {
            this.saveManager.save(Object.assign(Object.assign({}, this.resourcesFromSessionStorage), resources));
        }
    }
    get resourcesFromSessionStorage() {
        var _a;
        if ((_a = this.saveManager) === null || _a === void 0 ? void 0 : _a.load) {
            return this.saveManager.load();
        }
        return {};
    }
    loadResource(language, namespace, callback) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                // Percy fails when component discovery is unable to get a resource
                //
                if ((0, lodash_1.isEmpty)(this.resourceName)) {
                    this.lang[language] = {};
                }
                else {
                    const { data } = yield (0, elements_core_rest_transport_1.serviceApi)().get(`/v1.0/resourcesets/${this.resourceName}`, { params: { language: (_a = language === null || language === void 0 ? void 0 : language.slice) === null || _a === void 0 ? void 0 : _a.call(language, 0, 2) } });
                    this.lang[language] = this.ResourceAdaptor(data);
                }
                callback(null, this.lang[language]);
                this.saveToSessionStorage({ [language]: this.lang[language] });
            }
            catch (e) {
                callback(e, '');
            }
        });
    }
    // Not in use - create is mandatory but only used to missing translations
    // eslint-disable-next-line class-methods-use-this
    create() {
    }
}
exports.BackendManager = BackendManager;
// mandatory for this to work as a i18n plugin
BackendManager.type = 'backend';
//# sourceMappingURL=backend-manager.js.map